import type { Airflow } from '@aviata/platform-types';
import type { ComposerTranslation } from 'vue-i18n';

import { baggageLib } from '@/entities/baggage';

type BaggageUnit = 'KG' | 'PC';

const serializers: Record<
  BaggageUnit,
  (v: number, t: ComposerTranslation) => string
> = {
  KG: (v, t) => `${v} ${t('fareFamily.unit_kg')}`,
  PC: v => `${v} PC`,
};

export function baggageToString({
  baggage,
  t,
}: {
  baggage: Airflow.Segment.BaggageEntity;
  t: ComposerTranslation;
}): string {
  // Use the library to parse the baggage data
  const { count, value, unit } = baggageLib.parse(baggage) as {
    count: number;
    value: number;
    unit: BaggageUnit;
  };

  // We use a fallback just in case the API returns a unit not in our BaggageUnit type
  const serializer = serializers[unit] || (v => `${v} ${unit}`);
  const text = serializer(count > 0 ? value : 0, t);

  return count > 1 ? `${count} x ${text}` : text;
}
